import React from 'react';
import { Box, Typography, Button } from '@mui/material';

class ErrorBoundary extends React.Component {
	constructor(props) {
		super(props);

		this.state = { hasError: false, error: null };
	}

	static getDerivedStateFromError(error) {
		return { hasError: true, error };
	}

	componentDidCatch(error, errorInfo) {
		console.error('Error caught by boundary:', error, errorInfo);

	}

	render() {
		if (this.state.hasError) {
			return (
				<Box
					sx={{
						display: 'flex',
						flexDirection: 'column',
						alignItems: 'center',
						justifyContent: 'center',

						minHeight: '200px',
						p: 3,
						textAlign: 'center',
					}}
				>
					<Typography variant="h4" gutterBottom color="error">
						Oho! Jotain meni pieleen.
					</Typography>
					<Typography variant="body1" sx={{ mb: 3 }}>
						Pahoittelut häiriöstä. Yritä päivittää sivu.
					</Typography>
					<Button
						variant="contained"
						onClick={() => window.location.reload()}
					>
						Päivitä sivu

					</Button>
				</Box>
			);
		}

		return this.props.children;
	}
}

export default ErrorBoundary;
